__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__u-smqG__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__u-smqG__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__u-smqG__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__u-smqG__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__u-smqG__back-top-wrap",
  "categorySelect": "index-module-scss-module__u-smqG__categorySelect",
  "filterBar": "index-module-scss-module__u-smqG__filterBar",
  "filterTableSelect": "index-module-scss-module__u-smqG__filterTableSelect",
  "freqSelect": "index-module-scss-module__u-smqG__freqSelect",
  "group": "index-module-scss-module__u-smqG__group",
});
